import $ from 'jquery';
import EFOcats_submit from '../../../core/v2/submit/efocats_submit.js';

export default class EFOcats_curves_submit extends EFOcats_submit {
  /**
   * 項目作成
   */
  data_label_first() {
    this.$('.qa').each((index, element) => {
      const label = {};

      // 複数name修正（）
      label.title = $(element).find('.cat-title').first().text();

      const inputs = $(element).find('input,textarea,select');

      label.name = '';

      for (let inputIndex = 0; inputIndex < inputs.length; inputIndex++) {
        const input = inputs.eq(inputIndex);
        if (input.attr('name')) {
          label.name = input.attr('name');
          break;
        }
      }

      label.error = [];
      label.status = this.data_label_first_status(inputs);
      label.time = 0;
      this.analy_data.labeldata.push(label);
    });
  }
}
